/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function WrenchIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="wrench"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M16.768 4.404L15 6.172C14.219 6.953 14.219 8.219 15 9C15.781 9.781 17.047 9.781 17.828 9L19.596 7.232" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M10.05 11.121L4.747 16.425C3.966 17.206 3.966 18.472 4.747 19.253C5.528 20.034 6.794 20.034 7.575 19.253L12.879 13.95" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M10.05 11.121A4.757 4.757 45 0 1 16.768 4.404" data-tinysvg-shape="arc" data-tinysvg-arc="13.591 7.944 4.757 4.757 93.096 266.904 45 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M19.596 7.232A4.757 4.757 45 0 1 12.879 13.95" data-tinysvg-shape="arc" data-tinysvg-arc="16.056 10.409 4.757 4.757 273.096 446.904 45 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
